// extracted by mini-css-extract-plugin
module.exports = {"legendIconItem":"LegendIconItem-legendIconItem-2Xvde","icon":"LegendIconItem-icon-83pzm"};